var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('request-materials',{staticClass:"mt-4",attrs:{"title":"Bodega Móvil | Solicitudes de Material","typeRequest":_vm.TYPE_REQUESTS_MATERIALS.mobile_warehouses}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }